var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-radio-group',{attrs:{"direction":"horizontal","disabled":""},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_c('van-radio',{attrs:{"name":"1"}},[_vm._v("单选框 1")]),_c('van-radio',{attrs:{"name":"2"}},[_vm._v("单选框 2")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }